import { Img } from "@/components/site/Img";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#F9F6F0] py-10 md:py-14"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#EFEBE1]">
              <Img
                src="/images/about-angel.jpg"
                alt="A winged angel statue on a pedestal in a landscaped garden"
                className="w-full h-full object-cover"
                data-testid="about-image"
                loading="lazy"
              />
            </div>
            <div className="hidden md:flex items-center gap-4 mt-6 text-[11px] tracking-[0.28em] uppercase text-[#7A6547]">
              <span className="w-9 h-px bg-[#7A6547]" />
              <span>Greek-inspired winged garden statue</span>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2 lg:pl-6">
            <div className="section-eyebrow mb-5">
              <span>About Garden Fountains Yard Sculptures</span>
            </div>
            <h2
              data-testid="about-heading"
              className="font-serif font-light text-[#2C2A28] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8"
            >
              Built by hand
              <br />
              in <em className="not-italic text-[#7A6547]">Villa Rica.</em>
            </h2>

            <div className="space-y-5 text-[#3F3D3A] text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                Garden Fountains Yard Sculptures is a small Villa Rica shop led
                by Chris: custom fountains, statues, and outdoor pieces for
                homeowners, landscapers, and garden lovers who want something
                with character. Every piece is cast by hand to hold up
                outdoors, and Chris works with each customer to make sure it
                fits the space.
              </p>
            </div>
            <div className="mt-6 flex flex-col sm:flex-row sm:flex-wrap gap-x-8 gap-y-3">
              <a
                href="#contact"
                data-testid="about-custom-link"
                className="inline-flex items-center gap-2 text-[#7A6547] hover:text-[#5E4D35] text-[11px] tracking-[0.22em] uppercase border-b border-[#7A6547]/40 hover:border-[#7A6547] pb-1 transition-colors"
              >
                Plan a Custom Fountain
                <ArrowRight size={13} strokeWidth={1.5} />
              </a>
              <Link
                to="/available-now"
                data-testid="about-browse-link"
                className="inline-flex items-center gap-2 text-[#7A6547] hover:text-[#5E4D35] text-[11px] tracking-[0.22em] uppercase border-b border-[#7A6547]/40 hover:border-[#7A6547] pb-1 transition-colors"
              >
                Browse Available Pieces
                <ArrowRight size={13} strokeWidth={1.5} />
              </Link>
            </div>

            <div className="mt-8 flex items-center gap-4" data-testid="about-chris-strip">
              <Img
                src="/images/chris-working.jpg"
                alt="Chris hand-finishing a cast concrete piece beside a lion statue in the yard"
                className="w-28 h-36 md:w-32 md:h-40 object-cover object-top border border-[#D5CEBD] flex-shrink-0"
                sizes="128px"
                loading="lazy"
              />
              <div>
                <div className="text-[#2C2A28] text-sm font-medium">Chris, owner &amp; maker</div>
                <div className="text-[#5C5955] text-sm leading-relaxed">
                  Every piece cast, finished, and delivered by hand.
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-5 sm:gap-10 max-w-md border-t border-[#D5CEBD] pt-6">
              <div className="flex items-baseline sm:block gap-3">
                <div className="font-serif text-2xl md:text-3xl text-[#7A6547] font-light">
                  Owner-led
                </div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#5C5955] sm:mt-1">
                  Small local team
                </div>
              </div>
              <div className="flex items-baseline sm:block gap-3">
                <div className="font-serif text-2xl md:text-3xl text-[#7A6547] font-light">
                  Nationwide service
                </div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#5C5955] sm:mt-1">
                  Delivery &amp; setup
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
